export default __webpack_public_path__ + "static/media/home-nft-container.496cf88f.png";